import "./App.css";
import { path } from "./UrlApi/UrlApi";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RecoilRoot } from 'recoil';
import Login from "./Pages/Login/Login";
import OTP from "./Pages/Login/Otp";
import Main from "./Main/Main";
import DailyJobDetailsRecord from "./Pages/Menu/DailyJobDetailsRecord/DailyJobDetailsRecord";
import Employee from "./Pages/Menu/Employee/Employee";
import AssignPermissions from "./Pages/Menu/AssignPermissions/AssignPermissions";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import ReportsLogUserLogin from "./Pages/Reports/ReportsLogUserLogin/ReportsLogUserLogin";
import ReportsLogSendFile from "./Pages/Reports/ReportsLogSendFile/ReportsLogSendFile";
import EmailData from "./Pages/Menu/EmailData/EmailData";
import UserData from "./Pages/Menu/UserData/UserData"
import DocumentRecordDaily from "./Pages/Menu/DocumentRecordDaily/DocumentRecordDaily";
import Zone from "./Pages/Menu/Zone/Zone";
import WorkSummary from "./Pages/Reports/ReportsWorkSummary/WorkSummary";
import ReportsWorkSummaryByZone from "./Pages/Reports/ReportsWorkSummaryByZone/ReportsWorkSummaryByZone";
import DailyJobDetailsRecordNotSuccess from "./Pages/Menu/DailyJobDetailsRecordNotSuccess/DailyJobDetailsRecordNotSuccess";
import ReportsRecordDaily from "./Pages/Reports/ReportsRecordDaily/ReportsRecordDaily";
import DataDeletionReport from "./Pages/Reports/DataDeletionReport/DataDeletionReport";
import WorkArea from "./Pages/Menu/WorkArea/WorkArea";
import ReportChangePassword from "./Pages/Reports/ReportChangePassword/ReportChangePassword";

function App() {
  return (
    <>
      <RecoilRoot>
        <Router basename={path}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/otp" element={<OTP />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/main" element={<Main />} >
              <Route path="details/record" element={<DailyJobDetailsRecord />} />
              <Route path="details/record-not-success" element={<DailyJobDetailsRecordNotSuccess />} />
              <Route path="record-daily-entry" element={<DocumentRecordDaily />} />
              <Route path="employee/:type_id/:menu_name" element={<Employee />} />
              <Route path="user/:type_id/:menu_name" element={<UserData />} />
              <Route path="assign-permissions" element={<AssignPermissions />} />
              <Route path="report-log-userlogin" element={<ReportsLogUserLogin />} />
              <Route path="report-log-sendfile" element={<ReportsLogSendFile />} />
              <Route path="email-data" element={<EmailData />} />
              <Route path="zone" element={<Zone />} />
              <Route path="work-area" element={<WorkArea />} />
              <Route path="report-work-summary-report" element={<WorkSummary />} />
              <Route path="report-work-summary-report-by-zone/:type_id/:menu_name" element={<ReportsWorkSummaryByZone />} />
              <Route path="report-record-daily" element={<ReportsRecordDaily />} />
              <Route path="data-deletion-report" element={<DataDeletionReport />} />
              <Route path="report-change-password" element={<ReportChangePassword />} />
            </Route>
          </Routes>
        </Router>
      </RecoilRoot>
    </>
  );
}

export default App;
